// Prefer window.base_url from index.html; fallback for local dev.
const API_URL =
    (typeof window !== "undefined" && window.base_url) ||
    "http://localhost:8080/taxlab";

export function constructPathURL(path) {
    const sanitizedHost = API_URL.replace(/\/$/, "");
    const sanitizedPath = path.substring(0, 1) === "/" ? path : `/${path}`;

    return sanitizedHost + sanitizedPath;
}
